import { modalSubject, paywallSubject } from './constants';
import {
  AnyBlueconicEvent,
  BlueconicAppDownloadModalEvent,
  BlueconicCustomUrlModalEvent,
  BlueconicLeadCaptureModalEvent,
  BlueconicLeadCaptureModalHorizontalArticlesEvent,
  BlueconicLeadCaptureModalSingleArticleEvent,
  BlueconicLeadCaptureModalSplitImgEvent,
  BlueconicLeadCaptureModalVerticalArticlesEvent,
  BlueconicLeadCaptureModalWithNewslettersEvent,
  BlueconicNewsletterModalEvent,
  BlueconicPaywallEvent,
} from './eventsInterfaces';
import { BlueconicDialogues, BlueconicPaywallProps } from './propInterfaces';
import {
  isBlueconicAppDownloadModalProps,
  isBlueconicCustomUrlModalProps,
  isBlueconicLeadCaptureModalWithNewslettersProps,
  isBlueconicLeadCaptureProps,
  isBlueconicNewsletterModalProps,
  isBlueconicPaywallProps,
  isBlueconicSubscribeModalProps,
} from './typeGuards';

export function verifyBlueconicDialogue(event: AnyBlueconicEvent): boolean {
  if (!event || !event.data || !event.data.dialogueType) return false;

  const dialogueType = BlueconicDialogues[getEnumKeyByValue(event.data.dialogueType)];

  switch (dialogueType) {
    case BlueconicDialogues.CustomUrlModal:
      if (isBlueconicCustomUrlModalProps(event.data as BlueconicCustomUrlModalEvent['data'])) {
        modalSubject.next(event as BlueconicCustomUrlModalEvent);
        return true;
      }
      break;
    case BlueconicDialogues.AppDownload:
      if (isBlueconicAppDownloadModalProps(event.data)) {
        modalSubject.next(event as BlueconicAppDownloadModalEvent);
        return true;
      }
      break;
    case BlueconicDialogues.NewsletterModal:
      if (isBlueconicNewsletterModalProps(event.data as BlueconicNewsletterModalEvent['data'])) {
        modalSubject.next(event as BlueconicNewsletterModalEvent);
        return true;
      }
      break;
    case BlueconicDialogues.Paywall:
      if (isBlueconicPaywallProps(event.data as BlueconicPaywallProps)) {
        paywallSubject.next(event as BlueconicPaywallEvent);
        return true;
      }
      break;
    case BlueconicDialogues.LeadCaptureModal:
      if (isBlueconicLeadCaptureProps(event.data as BlueconicLeadCaptureModalEvent['data'])) {
        modalSubject.next(event as BlueconicLeadCaptureModalEvent);
        return true;
      }
      break;
    case BlueconicDialogues.LeadCaptureModalWithVerticalArticles:
      if (
        isBlueconicLeadCaptureProps(
          event.data as BlueconicLeadCaptureModalVerticalArticlesEvent['data']
        )
      ) {
        modalSubject.next(event as BlueconicLeadCaptureModalVerticalArticlesEvent);
        return true;
      }
      break;
    case BlueconicDialogues.LeadCaptureModalWithHorizontalArticles:
      if (
        isBlueconicLeadCaptureProps(
          event.data as BlueconicLeadCaptureModalHorizontalArticlesEvent['data']
        )
      ) {
        modalSubject.next(event as BlueconicLeadCaptureModalHorizontalArticlesEvent);
        return true;
      }
      break;
    case BlueconicDialogues.LeadCaptureModalWithSingleArticle:
      if (
        isBlueconicLeadCaptureProps(
          event.data as BlueconicLeadCaptureModalSingleArticleEvent['data']
        )
      ) {
        modalSubject.next(event as BlueconicLeadCaptureModalSingleArticleEvent);
        return true;
      }
      break;
    case BlueconicDialogues.LeadCaptureModalWithSplitImg:
      if (
        isBlueconicSubscribeModalProps(event.data as BlueconicLeadCaptureModalSplitImgEvent['data'])
      ) {
        modalSubject.next(event as BlueconicLeadCaptureModalSplitImgEvent);
        return true;
      }
      break;
    case BlueconicDialogues.LeadCaptureModalWithNewsletters:
      if (
        isBlueconicLeadCaptureModalWithNewslettersProps(
          event.data as BlueconicLeadCaptureModalWithNewslettersEvent['data']
        )
      ) {
        modalSubject.next(event as BlueconicLeadCaptureModalWithNewslettersEvent);
        return true;
      }
      break;
    default:
      return false;
  }

  return false;
}

function getEnumKeyByValue(value: string): keyof typeof BlueconicDialogues {
  return (Object.keys(BlueconicDialogues) as Array<keyof typeof BlueconicDialogues>).find(
    (key) => BlueconicDialogues[key] === value
  );
}
